import {
  formatError,
  loginSA,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
  verify2FALogin,
} from "../../services/AuthService";
import swal from "sweetalert";

// Actions type
export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";
export const LOGIN_2FA_REQUIRED_ACTION = "[login action] 2fa required";

function completeLogin(dispatch, response, navigate) {
  const user = response?.user;

  if (!user) {
    const msg = "Unexpected error, please try again.";
    dispatch(loginFailedAction(msg));
    swal("Error", msg, "error");
    return false;
  }

  if (user.role !== "superAdmin") {
    const msg =
      "Only Super Admin can have authorization to login to this space";
    dispatch(loginFailedAction(msg));
    swal("Error", msg, "error");
    return false;
  }

  if (!user.activate) {
    const msg = "Your account has been deactivated";
    dispatch(loginFailedAction(msg));
    swal("Error", msg, "error");
    return false;
  }

  localStorage.setItem("tokenLogin", response.tokenLogin);
  localStorage.setItem("email", user.email);
  dispatch(
    loginConfirmedAction({
      idToken: response.tokenLogin,
      tokenLogin: response.tokenLogin,
      email: user.email,
    })
  );
  navigate("/dashboard", { replace: true });
  return true;
}

// Signup action
export function signupAction(email, password, navigate) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        if (response?.data?.user?.role !== "superAdmin") {
          const msg =
            "Only Super Admin can have authorization to login to this space";
          dispatch(signupFailedAction(msg));
          swal("Error", msg, "error");
        } else {
          saveTokenInLocalStorage(response.data);
          runLogoutTimer(dispatch, response.data.expiresIn * 1000);
          dispatch(confirmedSignupAction(response.data));
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        const errorMessage =
          formatError(error?.response?.data) || "Failed to signup";
        dispatch(signupFailedAction(errorMessage));
        swal("Error", errorMessage, "error");
      });
  };
}

// Logout action
export function Logout(navigate) {
  localStorage.removeItem("tokenLogin");
  localStorage.removeItem("email");
  navigate("/login");

  return { type: LOGOUT_ACTION };
}

// Login action
export function loginAction(email, password, navigate) {
  return (dispatch) => {
    // Validation frontend
    if (!email || !password) {
      const msg = !email ? "Email is required." : "Password is required.";
      dispatch(loginFailedAction(msg));
      swal("Error", msg, "error");
      return Promise.resolve({ requires2FA: false });
    }

    // Appel backend
    return loginSA(email, password)
      .then((response) => {
        if (response?.requires2FA) {
          dispatch({
            type: LOGIN_2FA_REQUIRED_ACTION,
            payload: { tempToken: response.tempToken },
          });
          return {
            requires2FA: true,
            tempToken: response.tempToken,
          };
        }

        completeLogin(dispatch, response, navigate);
        return { requires2FA: false };
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message ||
          "Failed to login. Please try again.";
        dispatch(loginFailedAction(errorMessage));
        swal("Error", errorMessage, "error");
        return { requires2FA: false, error: true };
      });
  };
}

// Verify Google Authenticator code after password step
export function verify2FAAction(tempToken, code, navigate) {
  return (dispatch) => {
    if (!code || String(code).trim().length < 6) {
      const msg = "Enter the 6-digit code from Google Authenticator.";
      dispatch(loginFailedAction(msg));
      swal("Error", msg, "error");
      return Promise.resolve(false);
    }

    return verify2FALogin(tempToken, code)
      .then((response) => completeLogin(dispatch, response, navigate))
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message ||
          "Invalid authenticator code. Please try again.";
        dispatch(loginFailedAction(errorMessage));
        swal("Error", errorMessage, "error");
        return false;
      });
  };
}

// Action creators
export function loginFailedAction(data) {
  return { type: LOGIN_FAILED_ACTION, payload: data };
}

export function loginConfirmedAction(data) {
  return { type: LOGIN_CONFIRMED_ACTION, payload: data };
}

export function confirmedSignupAction(payload) {
  return { type: SIGNUP_CONFIRMED_ACTION, payload };
}

export function signupFailedAction(message) {
  return { type: SIGNUP_FAILED_ACTION, payload: message };
}

export function loadingToggleAction(status) {
  return { type: LOADING_TOGGLE_ACTION, payload: status };
}
